import React, { useEffect, useRef } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

const PcUniverse = () => {
  const { i18n, t } = useTranslation();

  const letterStyle = {
    backgroundImage: 'url(/img/v2/main/universe/pc_universe_top.png)',
    backgroundSize: '100%',
    backgroundPosition: ' top',
    backgroundRepeat: 'no-repeat',
  };

  const letterMidStyle = {
    backgroundImage: 'url(/img/v2/main/universe/pc_universe_mid.png)',
    backgroundSize: '100%',
    backgroundPosition: 'bottom',
    backgroundRepeat: 'repeat-y',
  };

  const letterBtmStyle = {
    backgroundImage: 'url(/img/v2/main/universe/pc_universe_bottom.png)',
    backgroundSize: '100%',
    backgroundPosition: 'top',
    backgroundRepeat: 'no-repeat',
  };

  useEffect(() => {}, []);

  return (
    <div className="text-center relative mt-[20%] mb-[150px] xs:mb-[200px] xhug:mt-[30%] ">
      <div
        className="breakword prose font-extrabold pt-[12%]  px-[20px] sm:px-[130px] text-[#c8be60]   font-TmoneyRoundWind  text-2xl sm:text-5xl"
        style={letterStyle}
      >
        {t('눈 떠보니 낯선 섬!')}
        <p className=" text-3xl breakword"> {t('여기는...?')}</p>
      </div>

      <div
        className="overflow-hidden h-full max-w-[100%]  px-[25px] sm:px-[130px]  "
        style={letterMidStyle}
      >
        <div className="text-[#989681] font-nuniSans text-xs #xxxs:text-[9px] xxs:text-sm sm:text-xl md:text-2xl ">
          <p className="pt-3 xxs:pt-8 underline decoration-[#e7e6de] underline-offset-4 breakword">
            {t('배를 타고 놀러 가던 중, 망가져 버린 핸들!')}{' '}
            {t('낯선 섬에 도착하면서 시작되는 이야기.')}
          </p>
          <p className="pt-4 xs:pt-8 underline decoration-[#e7e6de] underline-offset-4 breakword ">
            {t('에메랄드빛 바다.')}
            {t('버려진 리조트 시설.')}
            {t('귀여운 동물 친구들!')}
            <br />
            {t('걱정은 잠시 접고, 아름다운 섬을 둘러보세요.')}
          </p>
          <p className="pt-5 xs:pt-7 underline decoration-[#e7e6de] underline-offset-4 breakword ">
            {t('계획에 없던 뜻밖의 조난.')}{' '}
            {t('하지만 어쩌면, 그토록 기다리던 휴식과 만남.')} <br />
            {t('수영하고, 낚시하고, 불꽃놀이도 함께 해요!')}
            {t('그들의 조난 생활이 궁금하다면?')}
          </p>
        </div>
      </div>
      <div className="text-[#989681] font-nuniSans  w-full absolute mt-[-1px] text-xs #xxxs:text-[9px] xxs:text-sm sm:text-xl md:text-2xl">
        <div style={letterBtmStyle} className="pb-[15%]">
          <br />
          <p className="breakword pt-3 xs:pt-6 text-[#d0c664] no-underline tracking-tighter font-bold underline decoration-[#e7e6de] underline-offset-4 ">
            “{t('섬, 그래 여긴 섬. 우리가 만든 작은 섬')}”
          </p>
          <p className="underline decoration-[#e7e6de] underline-offset-4 px-20  pb-1  breakword">
            {t('7명과 당신만의 특별한 섬. 인더섬으로 어서 오세요!')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default observer(PcUniverse);
